import { render, staticRenderFns } from "./RetailerTag.vue?vue&type=template&id=7468444b&lang=pug"
import script from "./RetailerTag.vue?vue&type=script&lang=js"
export * from "./RetailerTag.vue?vue&type=script&lang=js"
import style0 from "./RetailerTag.vue?vue&type=style&index=0&id=7468444b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports